<template>
    <div v-if="!question.complete && !disabled" class="GlsFormQuestion">
        <header class="QuestionHeader">
            <h3>{{ question.metadata.title }}</h3>
            <div class="QuestionHeader__subtitle">
                {{ question.metadata.emptyInformation }}
            </div>
        </header>
        <AddressInput :value="modelValue" @input="$emit('update:modelValue', $event)" />
    </div>
    <div v-else-if="modelValue || (!question.complete && disabled)" class="GlsFormQuestion">
        <header class="QuestionHeader">
            <h3>{{ question.metadata.title }}</h3>
            <div class="QuestionHeader__subtitle">
                {{ disabled ? question.metadata.completedInformation : question.metadata.instructions }}
            </div>
        </header>
        <AddressInput :value="modelValue" disabled />
    </div>
    <div v-else class="GlsFormQuestion">
        <header class="QuestionHeader">
            <h3>{{ question.metadata.title }}</h3>
            <div class="QuestionHeader__subtitle">
                {{ question.metadata.emptyInformation }}
            </div>
        </header>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import Question from '@evidentid/ido-lib/interfaces/Question';

    import AddressInput from '@/components/forms/AddressInput.vue';
    import Address from '@/fields/interfaces/Address';

    // PRODUCT-26110 Task 12 (COMPONENT_V_MODEL): migrated to the Vue 3 v-model
    // contract. Consumed via v-model by google/GlsForm.vue. Its internal AddressInput
    // is a manual :value/@input site (AddressInput itself is unmigrated -- it is
    // never itself the target of a v-model directive).
    @Component({
        emits: [ 'update:modelValue' ],
        components: { AddressInput },
    })
    export default class GlsAddressQuestion extends Vue {
        @Prop({ type: Object })
        private question!: Question;

        @Prop({ type: Object, default: () => null })
        private modelValue!: Address;

        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;
    }
</script>
